import React from 'react';
import { YMaps, Map, Placemark } from '@pbe/react-yandex-maps';
import axios from 'axios';

import './MapPage.css';

const MapPage = ({
    setCurrentPage,
    setNewRecommAddress,
    setNewRecommCoords,
}) => {
    const apiKey = '4929539d-4d1c-4587-8673-848a8fc9cd56';

    // получение адреса и координат при клике на карту
    const handleMapClick = async (event) => {
        const coords = event.get('coords');

        setNewRecommCoords([coords[0], coords[1]]); // координаты места

        try {
            const geocodeResponse = await axios.get(
                'https://geocode-maps.yandex.ru/1.x/',
                {
                    params: {
                        apikey: apiKey,
                        format: 'json',
                        lang: 'RU-ru',
                        geocode: `${coords[1]},${coords[0]}`,
                    },
                }
            );

            const geoObject =
                geocodeResponse.data.response.GeoObjectCollection
                    .featureMember[0]?.GeoObject;

            if (geoObject) {
                const components =
                    geoObject.metaDataProperty.GeocoderMetaData.Address
                        .Components;

                const city = components.find(
                    (component) => component.kind === 'locality'
                )?.name;
                const street = components.find(
                    (component) => component.kind === 'street'
                )?.name;
                const house = components.find(
                    (component) => component.kind === 'house'
                )?.name;

                const formattedAddress = [city, street, house]
                    .filter((part) => part)
                    .join(', ');

                setNewRecommAddress(formattedAddress); // адрес места
                setCurrentPage('RecommendationsAdd');
            } else {
                console.error(
                    'Не удалось найти адрес для указанных координат.'
                );
            }
        } catch (error) {
            console.error('Ошибка обратного геокодирования:', error);
        }
    };

    return (
        <YMaps>
            <div className='map__wrapper'>
                <Map
                    defaultState={{ center: [55.75, 37.57], zoom: 15 }}
                    width='100%'
                    height='100%'
                    onClick={handleMapClick}
                />
            </div>
        </YMaps>
    );
};

export default MapPage;
